import api from "./api"

export const createVehicle = async (data) => {
  return await api.post('/vehicle/create-vehicle', data, {
    headers: {
      Authorization: localStorage.getItem("token")
    }
  })
}

export const getAllVehicle = async (page, pageSize) => {
  return await api.get(`/vehicle/get-all-vehicle?page=${page}&pageSize=${pageSize}`, {
    headers: {
      Authorization: localStorage.getItem("token")
    }
  });
}

export const getListVehicle = async () => {
  return await api.get(`/vehicle/list-vehicle`, {
    headers: {
      Authorization: localStorage.getItem("token")
    }
  });
}

export const getVehicleById = async (id) => {
  return await api.get(`/vehicle/get-vehicle-by-id/${id}`, {
    headers: {
      Authorization: localStorage.getItem("token")
    }
  });
}